import * as actionTypes from "../actions/actionTypes";

const initialState = {
    pageOneToPageTwoSignUp: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PAGE_ONE:
      return {
        ...state,
        pageOneToPageTwoSignUp: action.loginToRessetPassword === undefined ? false : action.loginToRessetPassword
      };
    default:
      return state;
  }
};

export default reducer;
